import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas, faPenToSquare, faRotate, faTrash, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import axios from 'axios';
import swal from 'sweetalert';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import logoBig from '../../../assets/img/logoBig.jpg';

function AppSettings() {
  const currentUser = useSelector((state) => state.data);
  const [permission, setPermission] = useState(false);
  const [version, setVersion] = useState(false);
  const [bank, setBank] = useState(false);
  const [bank1, setBank1] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editBankIndex, setEditBankIndex] = useState(false);

  const handleClose = () => {
    setAddModal(false);
    setEditModal(false);
  }

  const handlePermission = async (e) => {
    e.preventDefault();
    try {
      const form = e.target;
      let jsonData = {};
      Array.from(form.elements).forEach((item) => {
        if (item.name) {
          jsonData[item.name] = item.checked;
        }
      });
      const response = await axios.post("/admin/update-permissons", jsonData);
      const { message } = response.data;
      toast(message);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleVersion = async (e) => {
    e.preventDefault();
    const { version } = e.target;
    try {
      const response = await axios.post("/admin/update-app-version", { version: version.value });
      const { status, message } = response.data;
      if (status) {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleAddBank = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData();
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.type === 'file') {
          Array.from(item.files).forEach((file) => {
            formData.append(item.name, file);
          });
        } else {
          formData.append(item.name, item.value);
        }
      }
    });
    try {
      const response = await axios.post("/edit-bank", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      const { status, message } = response.data;
      if (status) {
        handleClose();
        getData3();
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleEditBank = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData();
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.type === 'file') {
          Array.from(item.files).forEach((file) => {
            formData.append(item.name, file);
          });
        } else {
          formData.append(item.name, item.value);
        }
      }
    });
    try {
      const response = await axios.post("/edit-bank", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      const { status, message } = response.data;
      if (status) {
        handleClose();
        getData3();
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData1 = async () => {
    try {
      const response = await axios.post('/history/getPermissions');
      const { status, data } = response.data;
      if (status) {
        setPermission(data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData2 = async () => {
    try {
      const response = await axios.post('/admin/get-app-version');
      const { status, data } = response.data;
      if (status) {
        setVersion(data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData3 = async () => {
    try {
      const response = await axios.get('/get-all-banks');
      const { status, data } = response.data;
      if (status) {
        setBank(data);
        setBank1(data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData1();
    getData2();
    getData3();
  }, []);
  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }
  const editBank = async (index) => {
    setEditBankIndex(index);
    setEditModal(true);
  };
  const deleteBank = async (bankId) => {
    const willApprove = await swal({
      title: "Are you sure?",
      text: "Are you sure that you want to delete this bank?",
      icon: "warning",
      dangerMode: true,
    });
    if (willApprove) {
      try {
        const response = await axios.post("/delete-bank", { bankId });
        const { status, message } = response.data;
        if (status) {
          getData3();
          toast(message);
        }
      }
      catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  const changeData = (e) => {
    setBank1(prev => ({ ...prev, [editBankIndex]: { ...prev[editBankIndex], [e.target.name]: e.target.value } }));
  };
  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">App Settings</h4>
              <Tabs
                defaultActiveKey="permissions"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="permissions" title="Permissions">
                  <form class="form-sample" onSubmit={handlePermission}>
                    <p class="card-description">
                      Permissions
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="prabhu_money_transfer" name="prabhu_money_transfer" checked={permission?.prabhu_money_transfer} onChange={(e) => setPermission({ ...permission, prabhu_money_transfer: e.target.checked })} />
                          <label class="form-check-label" for="prabhu_money_transfer">Prabhu Money Transfer</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="prabhu_csp_onboarding" name="prabhu_csp_onboarding" checked={permission?.prabhu_csp_onboarding} onChange={(e) => setPermission({ ...permission, prabhu_csp_onboarding: e.target.checked })} />
                          <label class="form-check-label" for="prabhu_csp_onboarding">Prabhu CSP Onboarding</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="ime_money_transfer" name="ime_money_transfer" checked={permission?.ime_money_transfer} onChange={(e) => setPermission({ ...permission, ime_money_transfer: e.target.checked })} />
                          <label class="form-check-label" for="ime_money_transfer">IME Money Transfer</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="ime_remittance_searching" name="ime_remittance_searching" checked={permission?.ime_remittance_searching} onChange={(e) => setPermission({ ...permission, ime_remittance_searching: e.target.checked })} />
                          <label class="form-check-label" for="ime_remittance_searching">IME Remittance Searching</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="ime_remittance_create_customer" name="ime_remittance_create_customer" checked={permission?.ime_remittance_create_customer} onChange={(e) => setPermission({ ...permission, ime_remittance_create_customer: e.target.checked })} />
                          <label class="form-check-label" for="ime_remittance_create_customer">IME Remittance Create Customer</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="ime_csp_onboarding" name="ime_csp_onboarding" checked={permission?.ime_csp_onboarding} onChange={(e) => setPermission({ ...permission, ime_csp_onboarding: e.target.checked })} />
                          <label class="form-check-label" for="ime_csp_onboarding">IME CSP Onboarding</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" id="online_transactions" name="online_transactions" checked={permission?.online_transactions} onChange={(e) => setPermission({ ...permission, online_transactions: e.target.checked })} />
                          <label class="form-check-label" for="online_transactions">Online Transactions</label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div>
                          <input type="submit" class="btn btn-primary" value="Update" />
                        </div>
                      </div>
                    </div>
                  </form>
                </Tab>
                <Tab eventKey="appVersion" title="App Version">
                  <form class="form-sample" onSubmit={handleVersion}>
                    <p class="card-description">
                      App Version
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <label>App Version</label>
                        <div>
                          <input type="text" class="form-control" name="version" value={version?.version} onChange={(e) => setVersion({ ...version, version: e.target.value })} />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div>
                          <input type="submit" class="btn btn-primary" value="Update" />
                        </div>
                      </div>
                    </div>
                  </form>
                </Tab>
                <Tab eventKey="bank" title="Bank">
                  <p class="card-description">
                    Bank
                    <button type="button" class="float-right btn btn-primary" onClick={(e) => setAddModal(true)}>Add</button>
                  </p>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Account Number</th>
                          <th>IFSC Code</th>
                          <th>Bank Name</th>
                          <th>Bank Branch</th>
                          <th>QR Code</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bank && bank.map((b, index) => (
                          <tr>
                            <td>{b.account_number}</td>
                            <td>{b.ifsc}</td>
                            <td>{b.bank_name}</td>
                            <td>{b.branch}</td>
                            <td>
                              {b.qr_code != "" && (
                                <img src={b.qr_code} width="100" />
                              )}
                            </td>
                            <td>
                              <Link onClick={(e) => editBank(index)}><FontAwesomeIcon icon={faPenToSquare} className="successIcon" title="Edit" /></Link>
                              <Link onClick={(e) => deleteBank(b._id)}><FontAwesomeIcon icon={faTrash} className="successIcon" title="Delete" /></Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <Modal show={addModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={handleAddBank}>
          <Modal.Header closeButton>
            <Modal.Title>Add Bank</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <label>Account Number</label>
                    <div>
                      <input type="text" class="form-control" name="account_number" required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>IFSC Code</label>
                    <div>
                      <input type="text" class="form-control" name="ifsc" required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>Bank Name</label>
                    <div>
                      <input type="text" class="form-control" name="bank_name" required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>Bank Branch</label>
                    <div>
                      <input type="text" class="form-control" name="branch" required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>QR Code</label>
                    <div>
                      <input type="file" class="form-control" name="qr_code" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={editModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={handleEditBank}>
          <Modal.Header closeButton>
            <Modal.Title>Update Bank</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input type="hidden" name="bankId" value={bank1?.[editBankIndex]?._id} />
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <label>Account Number</label>
                    <div>
                      <input type="text" class="form-control" name="account_number" value={bank1?.[editBankIndex]?.account_number} onChange={changeData} required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>IFSC Code</label>
                    <div>
                      <input type="text" class="form-control" name="ifsc" value={bank1?.[editBankIndex]?.ifsc} onChange={changeData} required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>Bank Name</label>
                    <div>
                      <input type="text" class="form-control" name="bank_name" value={bank1?.[editBankIndex]?.bank_name} onChange={changeData} required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>Bank Branch</label>
                    <div>
                      <input type="text" class="form-control" name="branch" value={bank1?.[editBankIndex]?.branch} onChange={changeData} required />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label>QR Code</label>
                    <div>
                      <input type="file" class="form-control" name="qr_code" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default AppSettings;
